import type { MinAvgMax } from "models";

export const band = (value: number): MinAvgMax => ({ min: value, avg: value, max: value });

export const bandAvg = (value: MinAvgMax | null | undefined): number => value?.avg ?? 0;

export const bandMin = (value: MinAvgMax | null | undefined): number => value?.min ?? 0;

export const bandMax = (value: MinAvgMax | null | undefined): number => value?.max ?? 0;
